import React from 'react';
import I18n from '../../../config/i18n';
import Format from '../../../utils/Formatter';
import { renderArrivalDepartureString, listTravelers, filterExtraCosts } from '../helpers';
import { Row, Col } from '../../../utils/grid/Grid';

/* eslint-disable react/prop-types */

export default () => [
  {
    legend: I18n.t('booking.journey'),
    content: [
      {
        label: I18n.t('booking.booking_period'),
        field: (props) => (
          <div className="booking-form-time-period">
            <div className="booking-duration-of-stay">
              {I18n.t('booking.duration_of_stay', { count: props.duration_of_stay })}
            </div>
            <div className="booking-arrival-departure annotation">
              {renderArrivalDepartureString(props)}
            </div>
          </div>
        ),
      },
      {
        label: I18n.t('booking.travelers'),
        field: (props) => (
          <ul className="booking-overview-travelers">
            {listTravelers(props).map((traveler, i) => (
              <li key={i} className="booking-overview-travelers-entry">
                {traveler}
              </li>
            ))}
          </ul>
        ),
      },
    ],
  },
  {
    condition: (props) => props.require_extra_group_information,
    legend: I18n.t('booking.group'),
    content: [
      {
        label: I18n.t('booking.group_years'),
        field: (props) => (
          <div className="booking-overview-group">
            {I18n.t('booking.group_years_sum', { min: props.group_min, max: props.group_max })}
          </div>
        ),
      },
      {
        label: I18n.t('booking.group_comment'),
        field: (props) => <div className="booking-overview-group">{props.group_comment}</div>,
      },
    ],
  },
  {
    legend: I18n.t('booking.tenant_data'),
    content: [
      {
        label: '',
        field: (props) => (
          <div className="booking-overview-tenant-data">
            <address className="booking-overview-tenant-data-address">
              {props.renter.name}
              <br />
              {props.renter.street}
              <br />
              {props.renter.invoice_postal_code} {props.renter.invoice_city}
              <br />
            </address>
            <dl className="booking-overview-tenant-data-contact">
              <div>
                <dt>{I18n.t('host.registrations_addons.edit_payment.invoice_phone')}</dt>
                <dd>{props.renter.invoice_phone}</dd>
              </div>
              <div>
                <dt>{I18n.t('host.registrations_addons.edit_payment.invoice_mobile_phone')}</dt>
                <dd>{props.renter.invoice_mobile_phone}</dd>
              </div>
              <div>
                <dt>{I18n.t('helpers.label.subscription.email')}</dt>
                <dd>{props.renter.email}</dd>
              </div>
            </dl>
          </div>
        ),
      },
    ],
  },
  {
    legend: I18n.t('booking.navigation.booking_info'),
    content: [
      {
        label: I18n.t('booking.price_total'),
        field: (props) => (
          <div className="booking-form-price">
            <div className="booking-form-price-amount">
              {I18n.l('currency', props.amount_total)}
            </div>
            <div className="booking-form-price-info">
              <div className="price-info-inclusive annotation">
                {props.cancel_ins_amount && props.cancel_ins_amount > 0
                  ? I18n.t('booking.inc_fees_cancellation')
                  : I18n.t(`booking.${props.is_holiday_home ? 'hh_inc_fees' : 'inc_fees'}`)}
              </div>
            </div>
          </div>
        ),
      },
    ],
  },
  {
    legend: I18n.t('booking.posible_host_cost'),
    content: (props) => (
      <div className="booking-overview-host-costs">
        <Row>
          <Col xs={12}>
            <div className="booking-form-notice">{I18n.t('booking.posible_host_cost_txt')}</div>
          </Col>
        </Row>
        {props.costs &&
          props.costs.map(({ label, value, info }, i) => (
            <Row key={i}>
              <Col xs={4} className="booking-form-label" tagName="label">
                {label}
              </Col>
              <Col xs={8} className="booking-form-field">
                <div className="booking-overview-host-costs-price">{value}</div>
                <div className="booking-overview-host-costs-info annotation">{info}</div>
              </Col>
            </Row>
          ))}
        {props.extraOptions &&
          props.extraOptions.map(({ label, value, info }, i) => (
            <Row key={i}>
              <Col xs={4} className="booking-form-label" tagName="label">
                {label}
              </Col>
              <Col xs={8} className="booking-form-field">
                <div className="booking-overview-host-costs-price">{value}</div>
                <div className="booking-overview-host-costs-info annotation">{info}</div>
              </Col>
            </Row>
          ))}
        {filterExtraCosts(props).length === 0 ? null : (
          <Row className="booking-overview-host-costs-additional-costs">
            <Col xs={12}>{I18n.t('booking.possible_costs_host')}</Col>
          </Row>
        )}
        {filterExtraCosts(props).map(({ label, value, info }, i) => (
          <Row key={i}>
            <Col xs={4} className="booking-form-label" tagName="label">
              {label}
            </Col>
            <Col xs={8} className="booking-form-field">
              <div className="booking-overview-host-costs-price">{value}</div>
              <div className="booking-overview-host-costs-info annotation">{info}</div>
            </Col>
          </Row>
        ))}
      </div>
    ),
  },
  {
    legend: '',
    content: [
      {
        label: '',
        field: () => (
          <button type="submit" className="booking-overview-submit">
            {I18n.t('buttons.reserve_now')}
          </button>
        ),
      },
    ],
  },
];

/* eslint-enable react/prop-types */
